// eslint-disable-next-line import/no-extraneous-dependencies
import { makeStyles } from '@material-ui/styles';
import { ITheme } from '../../../../typings/theme';

export default makeStyles((theme: ITheme) => ({
  table: {
    minWidth: 650,
    padding: 1,
  },
  title: {
    margin: 15,
  },
  subtitle: {
    fontSize: 18,
  },
  grid: {
    marginTop: 30,
  },
  dayWrapper: {
    position: 'relative',
  },
  hideOverflow: {
    overflow: 'hidden',
  },
  day: {
    width: 36,
    height: 36,
    fontSize: theme.typography.caption.fontSize,
    margin: '0 2px',
    color: 'inherit',
  },
  customDayHighlight: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: '2px',
    right: '2px',
    border: `1px solid ${theme.palette.secondary.main}`,
    borderRadius: '50%',
  },
  nonCurrentMonthDay: {
    color: theme.palette.text.disabled,
  },
  highlightNonCurrentMonthDay: {
    color: '#676767',
  },
  highlight: {
    background: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
  firstHighlight: {
    borderTopLeftRadius: '50%',
    borderBottomLeftRadius: '50%',
  },
  endHighlight: {
    borderTopRightRadius: '50%',
    borderBottomRightRadius: '50%',
  },
  gridItem: {
    '& .MuiPaper-elevation4': {
      boxShadow: 'none',
      backgroundColor: 'transparent',
    },
  },
}));
